export default defineNuxtPlugin(({ vueApp }) => {
  if (import.meta.client) {
    window.addEventListener("error", function (event) {
      console.error("Caught an error:", event.message);
      return false;
    });
  }
  vueApp.config.errorHandler = (err, instance, info) => {
    console.error("Caught an error:", err, instance, info);
  };
});
